<template lang="pug">
  v-layout.box-tus-coberturas-popup
    v-dialog(v-model="openPopup" persistent width="369" )
      v-card.box-card-coberturas
        v-card-text
          v-layout.box-title-coberturas(column align-center)
            v-flex
              span(style="font-size:15px;")
                b Estas son tus coberturas
          v-layout.box-table-coberturas(column)
            v-flex(v-if="textTitle1"  style="padding: 0.2em 0.5em !important;").box-detalle-cobertura
              span(style="color: #454A6C;")
                b {{textTitle1}}
            v-flex(v-if="textTitle1"  style="padding: 0.2em 0 !important;").box-detalle-cobertura
              v-layout.box-detalle-cobertura.box-detalle-cobertura-text(style="border-bottom:0px")
                v-flex(xs8)
                  span.nombre(style="font-size:14px") {{ coberturaPrincipal.nombre }}
                v-flex.box-detalle-cobertura-monto(xs4)
                  span(style="font-size:13px") {{tipoMoneda}} {{coberturaPrincipal.monto}}
            v-flex(style="padding: 0.2em 0.5em !important;").box-detalle-cobertura
              span(style="color: #454A6C;")
                b {{textTitle2||'Coberturas'}}
            v-flex(style="max-height:15em; overflow-y:auto")
              v-layout.box-detalle-cobertura.box-detalle-cobertura-text(v-for="cobertura in coberturaFormatter " :key="cobertura.id" )
                v-flex(xs8)
                  span.nombre(style="font-size:14px") {{ cobertura.nombre }}
                v-flex.box-detalle-cobertura-monto(xs4)
                  span(style="font-size:13px") {{tipoMoneda}} {{cobertura.monto}}
          v-layout.box-detalle-cobertura-text(style="margin: 1em auto")
            span(style="font-size:13px") Si deseas contratar más coberturas comunícate con tu &nbsp;
              b asesor.
        v-card-actions
          v-layout(align-center column)
            v-flex
              v-btn.box-btn-coberturas-popup(color="#EA0D90" @click="closePopup" )
                span(style="color: #ffffff; text-transform: capitalize") Entendido
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: [
    'openPopup',
    'coberturas',
    'tipoMoneda',
    'taggeo',
    'textTitle1',
    'textTitle2'
  ],
  data () {
    return {
      coberturaFormatter: [],
      coberturaPrincipal: {}
    }
  },
  methods: {
    ...mapActions('event', ['eventLog']),
    closePopup () {
      this.$emit('closePopup', '')
    }
  },
  mounted () {
    let self = this

    const metadata = {
      numeroPoliza: self.taggeo.numeroPoliza,
      antiguedad: self.taggeo.antiguedad,
      productoConsultado: self.taggeo.ramo,
      subproductoConsultado: self.taggeo.nombreProducto
    }
    self.$root.$emit('npsInactivity', {seccion: 'Mis seguros - Plan - Coberturas', metadata})

    self.eventLog({
      'tipoDocumento': self.taggeo.tipoDocumento,
      'numeroDocumento': self.taggeo.numeroDocumento,
      'categoria': 'Consulta',
      'nombre': self.taggeo.nombre,
      'datos': {
        'numeroPoliza': self.taggeo.numeroPoliza,
        'antiguedad': self.taggeo.antiguedad,
        'grupoProducto': self.taggeo.ramo,
        'producto': self.taggeo.nombreProducto,
        'navegacion': 'Plan',
        'dispositivo': 'mobile',
        'seccion': 'coberturas'
      }
    })

    self.coberturaFormatter = [...self.coberturas.map(cobertura => {
      let aux = {}
      aux.nombre = cobertura.nombre
      aux.monto = new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(cobertura.montoCobertura)

      return aux
    })]
    if (this.taggeo.nombreProducto.includes('VIDA') && this.taggeo.nombreProducto.includes('FREE')) {
      self.coberturaPrincipal = self.coberturaFormatter.find(c => c.tipo === 'PRINCIPAL') || self.coberturaFormatter.find(c => c.nombre.toUpperCase() === 'FALLECIMIENTO')
      self.coberturaFormatter = self.coberturaFormatter.filter(c => (c.tipo && c.tipo !== 'PRINCIPAL') || (!c.tipo && c.nombre.toUpperCase() !== 'FALLECIMIENTO'))
    } else {
      self.coberturaPrincipal = self.coberturaFormatter[0]
    }
  }

}
</script>

<style scoped>
.box-tus-coberturas-popup span {
  color: #1F1F1F;
}

.box-card-coberturas {
  padding: 2em 0.3em
}

.box-detalle-cobertura {
  padding: 1em 0.5em;
  border-bottom: 1px #C4C4C4 solid
}
.box-detalle-cobertura:last-child {
  border-bottom: 0px #C4C4C4 solid
}

.box-table-coberturas {
  border: 1px #C4C4C4 solid;
}

.box-title-coberturas {
  margin-bottom: 1em;
}

.box-title-coberturas span {
  color: #0855C4;
}

.box-detalle-cobertura-text .flex {
  display: flex;
}

.box-detalle-cobertura-text span {
  color: var(--text-color);
  text-align: justify !important;
  font-size: 0.8em;
  line-height: 1em;
}

.box-detalle-cobertura-text span.nombre {
  text-transform: lowercase;
}

.box-detalle-cobertura-text span.nombre::first-letter {
  text-transform: uppercase;
}

.box-detalle-cobertura-monto {
  display: flex;
  justify-content: right;
  align-self: center;
}

.box-btn-coberturas-popup {
  height: 3.5em;
  width: 10em;
}
</style>



// WEBPACK FOOTER //
// src/components/mis-seguros/PopupCoberturas.vue